import get from 'lodash/get';
import last from 'lodash/last';
import isEmpty from 'lodash/isEmpty';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import {ImagePicker} from 'components/forms/BasicFormFields';
import {createImageAction, startEditImageAction, uploadOriginalAndCreateImageAction} from 'pages/Images/actions';
import {extractResourceIdsWithPath} from 'utils/DBUtils';
import {createResourceTypeSelector} from 'resources/selectors';
import {updateRetailerItemInProgressAction} from 'pages/Rewards/actions';
import * as ResourceApi from 'api/resources';

const getImageItems = createResourceTypeSelector(ResourceApi.Types.Image);

const mapStateToProps = (state, ownProps) => {
  const possibleImages = getImageItems(state.resources);
  const {formProxy} = ownProps;

  // if the RetailerItem already exists, then the imageId will already be associated with that
  // object. otherwise it is without a parent resource (the user is likely in the process of
  // creating it), so we pull it from the Rewards reducer.
  const selectedImageId = get(formProxy.resource, 'imageId', null) || get(state.rewards.writingRetailerItemResource, 'imageId', null);

  const selectedImage = possibleImages.find(image => image.id === selectedImageId) || null;
  const hasOriginalImage = selectedImage ? Boolean(selectedImage.originalImageId) : false;

  const options = possibleImages.map(image => ({
    value: image.id,
    text: image.name
  }));

  if (selectedImage) {
    // if an image has been selected, push it to the front so the dropdown will show
    // it as the selected option. otherwise show an empty option with a message.
    options.push({
      value: selectedImage.id,
      text: selectedImage.name
    });
  } else {
    options.unshift({
      value: null,
      text: '-- Select Image --'
    });
  }

  let {creatingImageFor, isUploading} = state.images; // FIXME: isUploading doesn't exist in that
                                                        // reducer, but we need to derive it somehow
                                                        // regardless.

  if (isUploading == undefined) {
    isUploading = false;
  }                                                        
  const id = get(formProxy.resource, 'id', null);
  const field = last(formProxy.fieldPath);
  const loading = !isEmpty(creatingImageFor) && id === creatingImageFor.id && field === creatingImageFor.field;

  return {
    hasOriginalImage,
    isUploading,
    loading,
    options,
    possibleImages,
    selectedImageId,
    selectedImage
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  updateRetailerItemInProgress: updateRetailerItemInProgressAction,
  createImage: createImageAction,
  uploadOriginalAndCreateImageAction,
  editImageInfo: startEditImageAction
}, dispatch);

const ReceiptItemImagePicker = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => {
    // for when the resource already exists
    const {formProxy, imageType} = props;
    const {resourcePath} = formProxy;
    const rootResource = formProxy.baseResource;
    const modifiedResource = formProxy.resource;
    const parentIds = isEmpty(rootResource) ? [] : extractResourceIdsWithPath(rootResource, rootResource, resourcePath);
    const field = last(formProxy.fieldPath);

    const args = [
      imageType,
      rootResource,

      // the API will ignore this field if it's set to null, since it is not known before the parent
      // RetailerItem is actually created.
      get(modifiedResource, 'resourceId', null),

      resourcePath,
      formProxy.fieldPath,
      field,
      parentIds
    ];

    return {
      onBrowse: () => props.uploadOriginalAndCreateImageAction(...args),
      editImage: image => props.createImage(image.originalImageId, ...args),
      editImageInfo: (event, data) => props.editImageInfo(props.value),
      onValueChanged: value => {
        const nextImageId = value || null;
        const nextSelectedImage = props.possibleImages.find(image => image.id === nextImageId);

        if (get(nextSelectedImage, 'imageType', null) === 'original') {
          props.createImage(nextImageId, ...args);
        } else {
          props.updateRetailerItemInProgress({imageId: nextImageId});
          props.onValueChanged(nextImageId);
        }
      }
    };
  }),
  setDisplayName('ReceiptItemImagePicker')
)(ImagePicker);

export default ReceiptItemImagePicker;



// WEBPACK FOOTER //
// ./public/pages/Receipt/ReceiptItemImagePicker.jsx